import { PeriodOption } from '../../shared/components/date-range-picker/date-range-picker.component';
import { PaginationData } from '../../shared/components/pagination-bar/pagination-bar.component';

export const REWARDS_DEFAULT_PAGINATION: PaginationData = {
  currentPage: 1,
  totalPages: 1,
  totalItems: 0,
  itemsPerPage: 10,
};

export const REWARDS_ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100] as const;

export const REWARDS_DEFAULT_PERIOD = 'All Time' as const;

export const REWARDS_PERIOD_OPTIONS: PeriodOption[] = [
  { label: 'Today', value: 'Today' },
  { label: 'This Week', value: 'This Week' },
  { label: 'This Bi-Week', value: 'This Bi-Week' },
  { label: 'This Month', value: 'This Month' },
  { label: 'This Year', value: 'This Year' },
  { label: 'All Time', value: 'All Time' },
  { label: 'Custom', value: 'Custom' },
];

export const REWARDS_TOAST_LIFETIME = 5000;
